import styled from 'styled-components';
import { BHS_PRETO, BHS_VERDE, ESTADO_ERRO } from 'constants/cores';

export const AccessWrapper = styled.form`
  width: 100%;
  min-height: calc(100vh - 77px);
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    max-width: 510px;
    padding: 32px;
    display: grid;
    gap: 16px;

    background-color: #fff;
    border: none;
    border-radius: 8px;
    box-shadow: 0 9px 24px rgba(29, 37, 44, .15);

    h4 {
      margin: 0;

      color: ${BHS_PRETO};
      font-size: 28px;
      font-weight: lighter;
      text-align: center;
    }

    p {
      text-align: center;
    }

    span {
      color: ${ESTADO_ERRO};
      font-size: 14px;
      text-align: center;
    }
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  input {
    width: 360px;

    background-color: none;
    border: none;
    border-bottom: 1px solid ${BHS_VERDE};

    color: ${BHS_VERDE};
    font-size: 40px;
    text-align: center;

    &:disabled {
      color: #637381;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;

  .block-loading {
    padding: 0;
  }
`;
